import { signOut } from '../lib/api.js';
import Icon from './Icon.jsx';

// Shown instead of content when a screen cannot load. It always offers a way
// forward — the first version rendered a bare sentence, and the only escape
// from it was force-quitting the app.
export default function ErrorState({ error, onRetry, onBack }) {
  const msg = String(error?.message ?? error ?? 'Errore sconosciuto');
  const clocky = /issued at future|used before issued|clock/i.test(msg);
  // A bad signature or a rejected claim is still an auth problem even when the
  // words "jwt" or "token" never appear in the message.
  const authy = /jwt|token|unauthor|401|signature|suitable key|invalid claim/i.test(msg);

  return (
    <div className="errstate">
      <span className="ico"><Icon name="alert" size={22} /></span>
      <b>{clocky ? 'Sessione non ancora valida' : authy ? 'Sessione scaduta' : 'Non riesco a caricare'}</b>
      <p>
        {clocky
          ? 'Il server ha rifiutato la sessione per una differenza di orario di pochi secondi. Di solito basta riprovare.'
          : authy
            ? 'Rientra con Google per continuare.'
            : 'Controlla la connessione e riprova.'}
      </p>
      <code>{msg}</code>
      <div className="acts">
        <button className="btn primary" onClick={onRetry}>Riprova</button>
        {onBack && <button className="btn" onClick={onBack}>Tutti i viaggi</button>}
        <button className="btn quiet" onClick={() => signOut()}>
          {authy ? 'Esci e rientra' : 'Esci'}
        </button>
      </div>
    </div>
  );
}
